export const foreignCollectionExtraFields = [
  'Organisation',
  'Kontaktperson',
  'Telefon',
  'Mail',
  'Straße',
  'PLZ',
  'Ort'
]

export const bankingExtraFields = [
  'Kontoinhaber',
  'Bank',
  'IBAN',
  'BIC',
  'Verwendungszweck'
]

// Groups a flat list of collection plans by their parent's url, e.g. for looking up a
// collection-plan group's members via result[groupUrl].
export function groupCollectionPlansByParentUrl (collectionPlans) {
  const result = {}
  collectionPlans.forEach(plan => {
    if (!plan.parent) {
      return
    }
    if (!result[plan.parent]) {
      result[plan.parent] = []
    }
    result[plan.parent].push(plan)
  })
  return result
}
